import { render } from "./CheckboxField.vue?vue&type=template&id=3b06a7a9&scoped=true&lang=pug"
import script from "./CheckboxField.vue?vue&type=script&lang=js"
export * from "./CheckboxField.vue?vue&type=script&lang=js"

import "./CheckboxField.vue?vue&type=style&index=0&id=3b06a7a9&scoped=true&lang=sass"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b06a7a9"]])

export default __exports__